var map = {
	"./production.json": 926,
	"./staging.json": 927
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 925;


//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/content nonrecursive \.json$
// module id = 925
// module chunks = 65